import { useState, useEffect } from 'react';
import { fetchRegions, type SelectOption } from '../services/optionsService';

interface Result {
  regions: SelectOption[];
  loading: boolean;
}

export function useRegions(): Result {
  const [state, setState] = useState<Result>({ regions: [], loading: true });

  useEffect(() => {
    let cancelled = false;
    fetchRegions()
      .then((data) => {
        if (!cancelled) setState({ regions: data, loading: false });
      })
      .catch(() => {
        if (!cancelled) setState({ regions: [], loading: false });
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return state;
}
